import React from "react";
import styled from "styled-components";
import { prices, reducedVariants } from "../new-prices-20240411";

const pricesNew = [
  6.0, 6.1, 6.2, 6.3, 6.4, 6.5, 6.6, 6.7, 6.8, 6.9, 7.0, 7.1, 7.2, 7.3, 7.4,
  7.5, 7.6, 7.7, 7.8, 7.9, 8.0, 8.1, 8.2, 8.3, 8.4, 8.5, 8.6, 8.7, 8.8, 8.9,
  9.0, 9.1, 9.2, 9.3, 9.4, 9.5, 9.6, 9.7, 9.8, 9.9, 10.0, 10.1, 10.2, 10.3,
  10.4, 10.5, 10.6, 10.7, 10.8, 10.9, 11.0, 11.1, 11.2, 11.3, 11.4, 11.5, 11.6,
  11.7, 11.8, 11.9, 12.0, 12.1, 12.2, 12.3, 12.4, 12.5, 12.6, 12.7, 12.8, 12.9,
  13.0, 13.1, 13.2, 13.3, 13.4, 13.5, 13.6, 13.7, 13.8, 13.9, 14.0, 14.1, 14.2,
  14.3, 14.4, 14.5, 14.6, 14.7, 14.8, 14.9, 15.0, 15.1, 15.2, 15.3, 15.4, 15.5,
  15.6, 15.7, 15.8, 15.9, 16.0, 16.2, 16.4, 16.6, 16.8, 17.0, 17.2, 17.4, 17.6,
  17.8, 18.0, 18.2, 18.4, 18.6, 18.8, 19.0, 19.2, 19.4, 19.6, 19.8, 20.0, 20.2,
  20.4, 20.6, 20.8, 21.0, 21.2, 21.4, 21.6, 21.8, 22.0, 22.2, 22.4, 22.6, 22.8,
  23.0, 23.2, 23.4, 23.6, 23.8, 24.0, 24.2, 24.4, 24.6, 24.8, 25.0, 25.2, 25.4,
  25.6, 25.8, 26.0, 26.2, 26.4, 26.6, 26.8, 27.0, 27.2, 27.4, 27.6, 27.8, 28.0,
  28.2, 28.4, 28.6, 28.8, 29.0, 29.2, 29.4, 29.6, 29.8, 30.0, 30.2, 30.4, 30.6,
  30.8, 31.0, 31.2, 31.4, 31.6, 31.8, 32.0, 32.2, 32.4, 32.6, 32.8, 33.0, 33.2,
  33.4, 33.6, 33.8, 34.0, 34.2, 34.4, 34.6, 34.8, 35.0, 35.2, 35.4, 35.6, 35.8,
  36.0, 36.5, 37.0, 37.5, 38.0, 38.5, 39.0, 39.5, 40.0, 40.5, 41.0, 41.5, 42.0,
  42.5, 43.0, 43.5, 44.0, 44.5, 45.0, 45.5, 46.0, 46.5, 47.0, 47.5, 48.0, 48.5,
  49.0, 49.5, 50.0, 50.5, 51.0, 51.5, 52.0, 52.5, 53.0, 53.5, 54.0, 54.5, 55.0,
  55.5, 56.0, 56.5, 57.0, 57.5, 58.0, 58.5, 59.0, 59.5, 60.0, 60.5, 61.0, 61.5,
  62.0, 62.5, 63.0, 63.5, 64.0, 64.5, 65.0, 65.5, 66.0, 66.5, 67.0, 67.5, 68.0,
  68.5, 69.0, 69.5, 70.0, 70.5, 71.0, 71.5, 72.0, 72.5, 73.0, 73.5, 74.0, 74.5,
  75.0, 75.5, 76.0, 76.5, 77.0, 77.5, 78.0, 78.5, 79.0, 79.5, 80.0, 80.5, 81.0,
  81.5, 82.0, 82.5, 83.0, 83.5, 84.0, 84.5, 85.0, 85.5, 86.0, 87.0, 88.0, 89.0,
  90.0, 91.0, 92.0, 93.0, 94.0, 95.0, 96.0, 97.0, 98.0, 99.0, 100.0, 101.0,
  102.0, 103.0, 104.0, 105.0, 106.0, 107.0, 108.0, 109.0, 110.0, 111.0, 112.0,
  113.0, 114.0, 115.0, 116.0, 117.0, 118.0, 119.0, 120.0, 121.0, 122.0, 123.0,
  124.0, 125.0, 126.0, 127.0, 128.0, 129.0, 130.0, 131.0, 132.0, 133.0, 134.0,
  135.0, 136.0, 137.0, 138.0, 139.0, 140.0, 141.0, 142.0, 143.0, 144.0, 145.0,
  146.0, 147.0, 148.0, 149.0, 150.0, 151.0, 152.0, 153.0, 154.0, 155.0, 156.0,
  157.0, 158.0, 159.0, 160.0, 161.0, 162.0, 163.0, 164.0, 165.0, 166.0, 167.0,
  168.0, 169.0, 170.0, 171.0, 172.0, 173.0, 174.0, 175.0, 176.0, 177.0, 178.0,
  179.0, 180.0, 181.0, 182.0, 183.0, 184.0, 185.0,
];

const preisProQM = 60;

const Input = styled.input`
  margin-left: 12px;
  margin-right: 12px;
`;

const discounts = [
  { xOrMore: 2, discont: 0.25 },
  { xOrMore: 3, discont: 0.4 },
  { xOrMore: 5, discont: 0.45 },
  { xOrMore: 10, discont: 0.65 },
  { xOrMore: 25, discont: 0.7 },
  { xOrMore: 50, discont: 0.75 },
  { xOrMore: 100, discont: 0.8 },
  { xOrMore: 250, discont: 0.85 },
  { xOrMore: 500, discont: 0.9 },
];

//Aufpreis fuer mehrere Farben definieren
// const aufpreisFuerFarbe = 3

export default function PriceCalculatorPrinter(props) {
  function getDiscount(x) {
    let discount = 0;

    for (let i = 0; i < discounts.length; i++) {
      if (x >= discounts[i]?.xOrMore) {
        discount = discounts[i]?.discont;
      } else {
        break;
      }
    }

    return discount;
  }

  const inputField = props.lastUserInputField;
  const input = props.lastUserInput;
  const ratio = props.ratio;
  let hoeheBerechnet = input / ratio;
  hoeheBerechnet = hoeheBerechnet.toFixed(1);
  let breiteBerechnet = input * ratio;
  breiteBerechnet = breiteBerechnet.toFixed(1);
  let hoehe = inputField === "breite" ? hoeheBerechnet : input;
  let breite = inputField === "hoehe" ? breiteBerechnet : input;
  let flaecheInCM = breite * hoehe;
  let flaeche = flaecheInCM / 10000;
  let preis;
  let priceWithoutDiscount;

  // hier brauchen wir new price calculation

  if (
    props.folienTyp === "Matt" ||
    props.folienTyp === "Standard" ||
    props.folienTyp === "Milchglas"
  ) {
    //y = -0,7121x4 + 7,1569x3 - 27,535x2 + 73,575x + 6,1129
    let a = 0.7121 * flaeche * flaeche * flaeche * flaeche;
    let b = 7.1569 * flaeche * flaeche * flaeche;
    let c = 27.535 * flaeche * flaeche;
    let d = 73.575 * flaeche;
    let e = 5.2629; // -0.85 wurde abgezogen
    // console.log("preis before: ", b - c + d + e - a);
    priceWithoutDiscount = b - c + d + e - a;
    preis = b - c + d + e - a - (b - c + d + e - a) * getDiscount(props?.menge);
    let counter = 0;
    let result = 6;
    (function () {
      for (let i = 0; i < prices.length; i++) {
        if (preis <= prices[i]) {
          result = i;
          return;
        }
        counter = counter + 1;
      }
    })();
    preis = prices[result];
    if (preis < 6 * getDiscount(props?.menge)) {
      preis = 6 * getDiscount(props?.menge);
    }
    //check
    let counter2 = 0;
    let result2 = 6;
    (function () {
      for (let i = 0; i < prices.length; i++) {
        if (priceWithoutDiscount <= prices[i]) {
          result2 = i;
          return;
        }
        counter2 = counter2 + 1;
      }
    })();
    priceWithoutDiscount = prices[result2];
    if (priceWithoutDiscount < 6) {
      priceWithoutDiscount = 6;
    }
  } else if (
    props.folienTyp === "Hochwertig" ||
    props.folienTyp === "MattPremium"
  ) {
    //y = 1,5873x3 - 15,106x2 + 75,658x + 8,4825
    let a = 1.5873 * flaeche * flaeche * flaeche;
    let b = 15.106 * flaeche * flaeche;
    let c = 75.658 * flaeche;
    let d = 7.2425; // -1.24 wurde abgezogen
    priceWithoutDiscount = a - b + c + d;
    preis = a - b + c + d - (a - b + c + d) * getDiscount(props?.menge);
    let counter = 0;
    let result = 8;
    (function () {
      for (let i = 0; i < prices.length; i++) {
        if (preis <= prices[i]) {
          result = i;
          return;
        }
        counter = counter + 1;
      }
    })();
    preis = prices[result];

    if (preis < 8 * getDiscount(props?.menge)) {
      preis = 8 * getDiscount(props?.menge);
    }

    let counter2 = 0;
    let result2 = 8;
    (function () {
      for (let i = 0; i < prices.length; i++) {
        if (priceWithoutDiscount <= prices[i]) {
          result2 = i;
          return;
        }
        counter2 = counter2 + 1;
      }
    })();
    priceWithoutDiscount = prices[result2];
    if (priceWithoutDiscount < 8) {
      priceWithoutDiscount = 8;
    }
  }

  // new price calculation DO WE NEED CODE FROM ABOVE?
  const calculateBasisPreis = (area) => {
    let fixPreis = 11.5;
    if (area >= 0.02 && area <= 0.04) {
      fixPreis = 13;
    }
    if (area > 0.04 && area <= 0.81) {
      fixPreis = 16;
    }
    if (area > 0.81) {
      fixPreis = 13;
    }

    return area / 0.0182 + fixPreis;
  };

  const calculateKonturAufpreis = (area) => {
    if (area >= 0.49) {
      return 18;
    }
    if (area >= 0.36) {
      return 16;
    }
    if (area >= 0.25) {
      return 14;
    }
    if (area >= 0.16) {
      return 12;
    }
    if (area >= 0.09) {
      return 11;
    }
    if (area >= 0.04) {
      return 10;
    } else {
      return 8;
    }
  };

  let newPrice = calculateBasisPreis(flaeche);

  if (props.ausschnitt === "aussenform") {
    function calculateAussenformAufpreis(flaeche) {
      const basePrice = 18.8;
      const linearCoefficient = 0.015;
      const quadraticCoefficient = -2.3e-6;
      const cubicCoefficient = 2.17e-10;
      const quarticCoefficient = -7.56e-15;

      const newPrice =
        basePrice +
        linearCoefficient * flaeche +
        quadraticCoefficient * Math.pow(flaeche, 2) +
        cubicCoefficient * Math.pow(flaeche, 3) +
        quarticCoefficient * Math.pow(flaeche, 4);
      return newPrice;
    }
    newPrice = calculateAussenformAufpreis(flaeche * 10000);
  }

  if (props.ausschnitt === "kontur") {
    function calculateComplexPrice(flaeche) {
      const basePrice = 22.3;
      const linearCoefficient = 0.014;
      const quadraticCoefficient = -1.47e-6;
      const cubicCoefficient = 1.2e-10;
      const quarticCoefficient = -4.01e-15;

      const newPrice =
        basePrice +
        linearCoefficient * flaeche +
        quadraticCoefficient * Math.pow(flaeche, 2) +
        cubicCoefficient * Math.pow(flaeche, 3) +
        quarticCoefficient * Math.pow(flaeche, 4);
      return newPrice;
    }
    newPrice = calculateComplexPrice(flaeche * 10000);
  }

  if (!!props.gespiegelt) {
    newPrice += 15;
  }

  console.log("test");
  console.log({ newPrice, flaeche });

  // above is new code

  const gesamtpreis = (preis + props.farbenAufpreis) * props.menge;
  console.log({
    priceWithoutDiscount,
    "props.farbenAufpreis": props.farbenAufpreis,
  });
  const itemPrice = newPrice; //+ mirrored aufpreis
  const discountPercentage = getDiscount(props.menge);
  const reducedItemPreis = itemPrice - itemPrice * discountPercentage;

  let variantId = null;
  let priceFoundInArray = null;
  prices.forEach((price, id) => {
    if (price >= reducedItemPreis && !variantId) {
      variantId = id;
      priceFoundInArray = price;
    }
  });

  const total = priceFoundInArray * props.menge;

  return (
    <div className="auswahl">
      {props.preisError ? (
        <div>
          <p id="error-text">{props.errorText}</p>
        </div>
      ) : (
        <div></div>
      )}
      <form className="mk-form">
        {!props.preisError ? (
          <>
            <label className="mk-label" htmlFor="menge">
              Menge:
            </label>
            <Input
              className="mk-input"
              type="number"
              id="menge"
              name="menge"
              onChange={props.setMenge}
              value={props.menge}
            ></Input>
            <label className="mk-label" htmlFor="preis" id="x">
              x
            </label>
            <div>
              {getDiscount(props?.menge) ? (
                <div style={{ display: "flex" }}>
                  <label
                    className="mk-label"
                    style={{ textDecoration: "line-through" }}
                    htmlFor="preis"
                  >
                    {itemPrice.toFixed(2).replace(/\.(\d)$/, ".$10")}
                    {" EUR"}
                  </label>
                </div>
              ) : null}
              <div style={{ display: "flex" }}>
                <label className="mk-label" htmlFor="preis">
                  {priceFoundInArray?.toFixed(2).replace(/\.(\d)$/, ".$10")}
                  {" EUR"}
                </label>
                <label className="mk-label" htmlFor="preis">
                  Stückpreis
                </label>
              </div>
            </div>
          </>
        ) : (
          <>
            <label className="mk-label" htmlFor="menge">
              Menge:
            </label>
            <Input
              className="mk-input"
              type="number"
              id="menge"
              name="menge"
              onChange={props.setMenge}
              value={props.menge}
            ></Input>

            <label id="error-text">Nicht verfügbar!</label>
          </>
        )}
      </form>
      {getDiscount(props?.menge) ? (
        <label>
          Gesamtpreis: {total?.toFixed(2)} (Du sparst ca.{" "}
          {getDiscount(props?.menge) * 100}%)
        </label>
      ) : (
        <label>Gesamtpreis: {total?.toFixed(2)}</label>
      )}
      <table border="1" style={{ marginTop: "32px" }}>
        <tbody>
          <tr>
            <th style={{ backgroundColor: "#597282", color: "#fff" }}>Menge</th>
            <th style={{ backgroundColor: "#597282", color: "#fff" }}>
              Rabatt
            </th>
          </tr>
          <tr>
            <td>Kaufe 2+</td>
            <td>25%</td>
          </tr>
          <tr>
            <td>Kaufe 3+</td>
            <td>40%</td>
          </tr>
          <tr>
            <td>Kaufe 5+</td>
            <td>45%</td>
          </tr>
          <tr>
            <td>Kaufe 10+</td>
            <td>65%</td>
          </tr>
          <tr>
            <td>Kaufe 25+</td>
            <td>70%</td>
          </tr>
          <tr>
            <td>Kaufe 50+</td>
            <td>75%</td>
          </tr>
          <tr>
            <td>Kaufe 100+</td>
            <td>80%</td>
          </tr>
          <tr>
            <td>Kaufe 250+</td>
            <td>85%</td>
          </tr>
          <tr>
            <td>Kaufe 500+</td>
            <td>90%</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
